















import {Component, Prop, Vue} from "vue-property-decorator";
import {Pricing} from "../../api";
import {SeatSelection} from "./models/SeatSelection";

@Component({
  components: {}
})
export default class ReservationItemReadonly extends Vue {
  @Prop() public selectedItem!: SeatSelection | null;
  @Prop() public index!: number;

  public selectedPrice: Pricing | null = null;
}
